import $ from 'static/script/libs/jquery';
import defineComponent from 'flight';
import _ from 'static/script/libs/underscore';
import RecentlyViewedItemsStorage from 'static/script/app/models/recently-viewed-items-storage';
import Logger from 'static/script/utils/logger';

function StoreAsRecentlyViewedItem() {
    this.MAX_NO_ITEMS = 4;
    this._recentlyViewedItemsStorage = new RecentlyViewedItemsStorage(this.MAX_NO_ITEMS);

    this.defaultAttrs({
        currentImage: '.image-gallery img',
        vipTitle: 'h1',
        itemId: null
    });

    this._storeAsRecentlyViewedItem = function () {
        let title = this.select('vipTitle').text();
        let currentUrl = window.location.href;
        let rawImageUrl = this.select('currentImage').attr('src');

        if (!this._isValidViewedItem(title, rawImageUrl, currentUrl)) {
            return;
        }

        let imageUrl = this._changeSizeInImageUrl(rawImageUrl, 'preview');

        try {
            this._recentlyViewedItemsStorage.saveItem(this.attr.itemId, currentUrl, imageUrl, title);
        } catch (ex) {
            this.logInfo(ex, 'Failed to save recently viewed item');
            if (this._recentlyViewedItemsStorage) {
                this._recentlyViewedItemsStorage.clearItems();
            }
        }
    };

    this._isValidViewedItem = function (title, imageUrl, currentUrl) {
        return imageUrl && imageUrl.length > 0 && title && title.length > 0 && currentUrl && currentUrl.length > 0;
    };

    this._changeSizeInImageUrl = function (url, size) {
        return url.replace(/\/images\//gi, '/' + size + '/');
    };

    this.after('initialize', function () {
        if (document.readyState && (document.readyState === 'complete' || document.readyState.state === 'complete')) {
            this._storeAsRecentlyViewedItem();
        } else {
            $(window).on('load', this._storeAsRecentlyViewedItem.bind(this));
        }

        this.on(document, 'ui:navigation:after-page-change', this._storeAsRecentlyViewedItem);
    });
}

module.exports = Logger.mixin(StoreAsRecentlyViewedItem);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/view-item/store-as-recently-viewed-item.js